import calculArrondi from '@/services/calcul/calculArrondi';
import formatIsoDate from '@/services/general/formatIsoDate';
import { UNITE, ANNEE, POURCENTAGE } from '@/configuration/devisConf';
import genererModeCalculHonoraire from '@/services/devis/genererModeCalculHonoaire';

export function genererDataLocation(payload, budget) {
  const { propriete, produit, fournisseurId, ligneCommandeId } = payload;
  const { dateDebut, dateFin } = budget;
  let remise = 0;
  let uniteVente = ANNEE;
  let prixUnitaire = budget[propriete];
  let quantite = 1;
  let modeCalculHonoraire = genererModeCalculHonoraire();

  switch(propriete) {
    case 'location':
      prixUnitaire = budget.prixUnitaireBrut != null ? budget.prixUnitaireBrut : budget.prixBrutNegocie;
      quantite = budget.quantiteBrut != null ? budget.quantiteBrut : 1;
      uniteVente = budget.uniteQteBrut || ANNEE;
      remise = budget.remise.remise;
      break;
    case 'tlpe':
      prixUnitaire = budget.prixUnitaireTlpe != null ? budget.prixUnitaireTlpe : budget[propriete];
      quantite = budget.quantiteTlpe != null ? budget.quantiteTlpe : 1;
      uniteVente = budget.uniteQteTlpe || ANNEE;
      break;
    case 'fraisTechnique':
      uniteVente = UNITE;
      break;
    case 'honoraires':
      modeCalculHonoraire = budget.modeCalculHonoraire;
      break;
    default:
      break;
  }

  if (!produit) return null;

  return {
    remise,
    budgetRemise: budget.remise,
    quantite,
    produitEnfant: produit,
    libelle: produit.libelle,
    produitEnfantId: produit.id,
    fournisseurId,
    uniteVente,
    typeRemise: POURCENTAGE,
    dateFin: formatIsoDate(dateFin),
    dateDebut: formatIsoDate(dateDebut),
    prixUnitaire: calculArrondi(prixUnitaire),
    ligneCommandeId,
    modeCalculHonoraire,
  }
}
